import PropTypes from 'prop-types';
import { FormGroup, Label, TextField } from '@celltrak/ui-components';
import noop from 'lodash/noop';

import { credentialForm } from '../../constants';

import styles from './TaxonomyField.module.scss';

const TaxonomyField = ({ value, onChange, disabled }) => {
  const handleValueChange = event => onChange(event);

  return (
    <div className={styles.taxonomyField}>
      <FormGroup>
        <Label size="sm" for={credentialForm.taxonomyId}>
          {credentialForm.taxonomyLabel}
        </Label>
        <TextField
          id={credentialForm.taxonomyId}
          size="sm"
          value={value}
          onChange={handleValueChange}
          disabled={disabled}
        />
      </FormGroup>
    </div>
  );
};

TaxonomyField.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
};

TaxonomyField.defaultProps = {
  value: '',
  onChange: noop,
  disabled: false,
};

export default TaxonomyField;
